import React, { Fragment, useEffect, useState } from "react";
import BloodPressure from "./vitalsgraph/BloodPressure";
import Temperature from "./vitalsgraph/Temperature";
import Glucose from "./vitalsgraph/Glucose";
import Uricacid from "./vitalsgraph/Uricacid";
import Pulse from "./vitalsgraph/Pulse";
import Cholesterol from "./vitalsgraph/Cholesterol";
import Respiratory from "./vitalsgraph/Respiratory";
import Weight from "./vitalsgraph/Weight";
import Box from "@material-ui/core/Box";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabPanel from "../../utils/TabPanel";
import { Grid, makeStyles, Paper } from "@material-ui/core";

const useStyle = makeStyles({
  indicatorLeft: {
    left: "0px",
  },
});

const Vitals = ({ patient_id, connection }) => {
  const classes = useStyle();
  const [category, setCategory] = useState("temp");

  const handleCategory = (event, newCategory) => {
    event.persist();
    setCategory(newCategory);
  };

  useEffect(() => {}, [patient_id]);

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Box clone order={{ xs: 2, sm: 2, md: 1 }}>
          <Grid item xs={12} sm={12} md={10}>
            <Box component={Paper} elevation={2} p={2}>
              <Box>
                <TabPanel value={category} index={"temp"}>
                  <Temperature
                    patient_id={patient_id}
                    connection={connection}
                  />
                </TabPanel>

                <TabPanel value={category} index={"bp"}>
                  <BloodPressure
                    patient_id={patient_id}
                    connection={connection}
                  />
                </TabPanel>

                <TabPanel value={category} index={"pulse"}>
                  <Pulse patient_id={patient_id} connection={connection} />
                </TabPanel>

                <TabPanel value={category} index={"respi"}>
                  <Respiratory
                    patient_id={patient_id}
                    connection={connection}
                  />
                </TabPanel>

                <TabPanel value={category} index={"weight"}>
                  <Weight patient_id={patient_id} connection={connection} />
                </TabPanel>

                <TabPanel value={category} index={"glucose"}>
                  <Glucose patient_id={patient_id} connection={connection} />
                </TabPanel>

                <TabPanel value={category} index={"uric"}>
                  <Uricacid patient_id={patient_id} connection={connection} />
                </TabPanel>

                <TabPanel value={category} index={"choles"}>
                  <Cholesterol
                    patient_id={patient_id}
                    connection={connection}
                  />
                </TabPanel>
              </Box>
            </Box>
          </Grid>
        </Box>
        <Box clone order={{ xs: 1, sm: 1, md: 2 }}>
          <Grid item xs={12} sm={12} md={2}>
            <Paper variant={"outlined"} component={Box} p={1}>
              <Tabs
                value={category}
                onChange={handleCategory}
                indicatorColor="primary"
                textColor="primary"
                scrollButtons="on"
                variant="scrollable"
                orientation={
                  window.innerWidth > 959 ? "vertical" : "horizontal"
                }
                classes={{
                  indicator: classes.indicatorLeft,
                }}
              >
                <Tab wrapped value="temp" label="Temp" />
                <Tab wrapped value="bp" label="Blood Pressure" />
                <Tab wrapped value="pulse" label="Pulse" />
                <Tab wrapped value="respi" label="Respiratory" />
                <Tab wrapped value="weight" label="Weight" />
                <Tab wrapped value="glucose" label="Glucose" />
                <Tab wrapped value="uric" label="Uric Acid" />
                <Tab wrapped value="choles" label="Cholesterol" />
              </Tabs>
            </Paper>
          </Grid>
        </Box>
      </Grid>
    </Fragment>
  );
};

export default Vitals;
